import '../../tables/Table.module.css'
import '../../css_styles/button_styles.css'
import PagePrev from '../../tables/PagePrev'
import PageNext from '../../tables/PageNext'
import IncreasePrecision from './IncreasePrecision'
import ReducePrecision from './ReducePrecision'
import classes from '../../tables/Table.module.css'
import { useState, useEffect } from 'react';


function DataUploadTable(props) {

    const [numRows, setNumRows] = useState(0)
    const [tableRows, setTableRows] = useState([])
    const [showPageNav, setShowPageNav ] = useState(false);
    const [nextActive, setNextActive] = useState(false);
    const [prevActive, setPrevActive] = useState(false);
    const [tableEmpty, setTableEmpty ] = useState(true);
    const [showMin, setShowMin] = useState(0);
    const [showMax, setShowMax] = useState(0);
    const [idSlice, setIdSlice] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); //set litemsPerPage = 10 as default
    const [precision, setPrecision] = useState([])


    useEffect(() => {

        setNumRows(props.tableRows.length)
        setIdSlice(1);
        setShowPageNav(false);
        setNextActive(false);
        setPrevActive(false);
        setTableEmpty(true);

        if (props.tableRows.length > 0){
            setTableEmpty(false)
            setShowMin(1);
            if(props.itemsPerPage !== undefined && props.itemsPerPage !== null) 
            {
             setShowMax(Math.min(props.itemsPerPage, props.tableRows.length));
            }
            else {
            setShowMax(Math.min(props.itemsPerPage, props.tableRows.length));
            }
        }
        if (props.tableRows.length > props.itemsPerPage)
        {
            setShowPageNav(true)
            setNextActive(true);
        }        
        if(props.itemsPerPage !== undefined && props.itemsPerPage !== null) 
        {
             setItemsPerPage(props.itemsPerPage); 
        }

    }, [props.tableRows.length, props.itemsPerPage]);

    useEffect(() => {
        setTableRows(props.tableRows)
    }, [props.tableRows]);

    useEffect(() => {
        setPrecision(props.displayPrecision)
    }, [props.displayPrecision]);

    let tableHead = (
        <>

            <tr>
                {props.colNames.map((columnName, index) => {
                    if (columnName !== '' && columnName !== 'Strategy') {
                        if (!precision) {
                            return (
                                <th key={`colname_${index}`} style={{verticalAlign: 'top'}}>
                                    <div style={{display:'flex'}}>
                                        {columnName} 
                                    </div>
                                </th>
                            );
                        }
                        return (
                            <th key={`colname_${index}`} style={{verticalAlign: 'top'}}>
                                <div style={{display:'flex'}}>
                                    {columnName} 
                                    <div style={{margin:'0px', marginLeft:'-10px'}}></div>
                                    <IncreasePrecision id={`increase_${index-1}`} handleClick={props.handleDisplayPrecision} /> 
                                    <ReducePrecision id={`reduce_${index-1}`} handleClick={props.handleDisplayPrecision} />
                                </div>
                            </th>
                        );
                    } else {
                        return (
                            <th key={`colname_${index}`} style={{verticalAlign: 'top'}}>
                                {columnName}
                            </th>
                        );
                    }
                })}
            </tr>
        </>
    );

    let tableBody = tableRows.slice(showMin-1, showMax).map((row, rowIndex) => {
        let highlight_style = {}; // Initialize highlight style
        if (row[props.highlight_key] === props.highlight_target && props.highlight_key) {
            highlight_style = { background: 'var(--aixelo-gray-light)' }; // Set background to red if condition is met
        }
    
        return (
            <tr key={`row_${rowIndex}`} style={highlight_style}>
                {Object.keys(row).map((key, id) => {
                    if (key === 'selected') {
                        return (
                            <td key={`${key}_${rowIndex+(idSlice-1)*itemsPerPage}`} style={{width:'30px', verticalAlign: 'top'}} >
                                <input 
                                    style={{ transform: 'scale(0.9)' }}
                                    id={`${key}_${rowIndex+(idSlice-1)*itemsPerPage}`} 
                                    onChange={props.onSelect} 
                                    type='checkbox' 
                                    checked={row[key]} 
                                />
                            </td>
                        );
                    }

                    else {
                        if (row[key] === '') { 
                            return (
                                <td className={classes.paginated} key={`${key}_${rowIndex+(idSlice-1)*itemsPerPage}`} style={{verticalAlign: 'top'}}>
                                    &nbsp;
                                </td>);
                        }
                        else if (typeof row[key] === "boolean"){
                            return (<td className={classes.paginated} key={`${key}_${rowIndex+(idSlice-1)*itemsPerPage}`} style={{verticalAlign: 'top'}}>
                                        {row[key].toString()}
                                    </td>);
                        }
                        else {
                            if (!precision) {
                                return (
                                    <td className={classes.paginated} key={`${key}_${rowIndex+(idSlice-1)*itemsPerPage}`} style={{verticalAlign: 'top'}}>
                                        {parseFloat(row[key])}
                                    </td>);
                            }
                            else {
                                return (
                                    <td className={classes.paginated} key={`${key}_${rowIndex+(idSlice-1)*itemsPerPage}`} style={{verticalAlign: 'top'}}>
                                    {parseFloat(row[key]).toPrecision(precision[id-2])}
                                    </td>);
                            }
                        }
                    }
                })}
            </tr>
        );
    });


    function handlePagePrev() {
        let new_count = idSlice - 1;
        setShowMin((new_count - 1)*itemsPerPage +1 )
        if( (new_count - 1)*itemsPerPage +1 === 1 ) { setPrevActive(false);}
        setShowMax((new_count)*itemsPerPage )
        setNextActive(true);
        setIdSlice(new_count);
    }


    function handlePageNext() {
        let new_count = idSlice + 1;
        let old_count = idSlice;
        setShowMin((old_count)*itemsPerPage +1 )
        if( (showMax + itemsPerPage) >= numRows ) 
        {
            setNextActive(false);
            setShowMax(numRows);
        }
        else {
            setShowMax((new_count)*itemsPerPage )
        } 
        setPrevActive(true);
        setIdSlice(new_count);
    }


    let show_min_max=(<>{showMin}-{showMax} of {numRows}</>);
    if(showMin === showMax){ show_min_max=(<>{showMin} of {numRows}</>); }

    let pageNav = (<></>);
    if (!tableEmpty) {
        pageNav = (<>
            <div className={classes.page_nav} style={{position:'relative', height:'20px', width: '100%'}}>
                <div style={{paddingRight:'20px', paddingBottom:'4px', }}>{show_min_max} </div>
            </div>
        </>);
    }
    if (!tableEmpty && showPageNav) {
        pageNav = (<>
            <div className={classes.page_nav} style={{position:'relative', height:'25px', width: '100%'}}>
                <PagePrev handleClick={handlePagePrev} active={prevActive}/>   
                <PageNext handleClick={handlePageNext} active={nextActive}/>
                <div style={{paddingBottom:'4px', paddingLeft:'10px'}}>{show_min_max} </div>
            </div>
        </>);
    }


    let actionPanel = (<></>);
    if (props.actionsOnSelect !== undefined && props.actionsOnSelect !== null) {
        actionPanel = props.actionsOnSelect.map((action, index) => {
            if(index===0){
                return (<>
                <button className={'tableButton'} style={{width:'120px'}} key={`action_${index}`} onClick={action.action}>
                    {action.title}
                </button>
                </>);
            }
            else {
                return (<>
                <button className={'tableButton'} style={{width:'60px'}} key={`action_${index}`} onClick={action.action}>
                    {action.title}
                </button>
                </>);
            }
        });
    }


    return(<>
        {pageNav}
        {/* <div style={{display:'flex', gap: '0px', padding:'0px', margin:'0px'}}>
            {actionPanel}
        </div> */}
        <table className={classes.paginated} >
            <thead >
                {tableHead}
            </thead>
            <tr><div style={{height: '4px'}} colSpan={props.colNames.length}></div></tr>
            <tbody style={{border: '0.5px solid var(--aixelo-gray-light)'}}>
                {tableBody}
            </tbody>
        </table>
        <div style={{display:'flex', gap: '0px', padding:'0px', margin:'0px', marginTop:'5px'}}>
            {actionPanel}
        </div>
    </>
    );

}



export default DataUploadTable;